// 生成带 userToken 的 AI Fleet 访问链接的工具函数

/**
 * 生成带有 userToken 的 AI Fleet 页面访问链接
 * @param {string} userToken - 用户的 userToken
 * @param {string} baseUrl - 基础 URL，默认为当前环境
 * @returns {string} 完整的访问链接
 */
export const generateAIFleetTokenLink = (userToken, baseUrl = window.location.origin) => {
  if (!userToken) {
    throw new Error('userToken 不能为空');
  }
  
  // 构建 URL
  const url = new URL('/ai-fleet', baseUrl);
  url.searchParams.set('userToken', userToken);
  
  return url.toString();
};

/**
 * 从用户信息中提取 userToken 并生成链接
 * @param {Object} userInfo - 用户信息对象
 * @param {string} baseUrl - 基础 URL
 * @returns {string|null} 访问链接或 null
 */
export const generateAIFleetLinkFromUserInfo = (userInfo, baseUrl = window.location.origin) => {
  if (!userInfo || !userInfo.userToken) {
    console.warn('用户信息中没有 userToken');
    return null;
  }
  
  return generateAIFleetTokenLink(userInfo.userToken, baseUrl);
};

/**
 * 示例：如何使用这些函数
 * 
 * // 方式1：直接使用 userToken
 * const userToken = "user_token_here";
 * const link = generateAIFleetTokenLink(userToken);
 * console.log(link); // http://localhost:3000/ai-fleet?userToken=user_token_here
 * 
 * // 方式2：从 localStorage 中的用户信息生成
 * const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
 * const link = generateAIFleetLinkFromUserInfo(userInfo);
 * if (link) {
 *   console.log(link);
 * }
 * 
 * // 方式3：为其他域名生成链接
 * const prodLink = generateAIFleetTokenLink(userToken, 'https://your-domain.com');
 * console.log(prodLink); // https://your-domain.com/ai-fleet?userToken=user_token_here
 */ 